export const isRecord = <T>(argument: T): argument is Record<any, any> => (
  typeof argument === 'object' && !Array.isArray(argument)
);
